export default __webpack_public_path__ + "static/media/iconNuvemArquivo.dcac1a01.svg";